export default "__VITE_ASSET__BZBGM_IM__"